<template>
    <div class="classify">
        <div class="flex align-center justify-between classify-t">
            <div class="classify-t-tit">{{ $t('动态') }}</div>
        </div>

        <div class="list" ref="listContainer" @scroll="handleScroll">
            <div class="classify-list">
                <div class="classify-row" v-for="(row, rowIndex) in categories" :key="rowIndex">
                <div ref="dynamicCard" class="list-box" v-for="(e, i) in row" :key="e.id || i" :data-dynamic-id="e.id" @click="onTopic(e.id)">
                    <div class="img-container">
                        <img :src="e.thumb" alt="" class="img-container-img">
                    </div>
                    <div class="list-box-title">{{ e.title }}</div>
                    <div class="list-box-txt">
                        <div class="list-box-txt-box">
                            <div class="list-box-txt-box-l">
                                <div class="list-box-desc">{{ e.desc }}</div>
                            </div>
                            <div class="list-box-txt-box-r">
                                <div class="list-box-txt-box-r-cz" @click.stop="onPraise(e)">
                                    <img src="../../../../static/images/icon/icon39.png" alt="" v-if="e.is_zan">
                                    <img src="../../../../static/images/icon/icon38.png" alt="" v-else>
                                    <div>{{ e.zan_num }}</div>
                                </div>
                                <div class="list-box-txt-box-r-cz" @click.stop="onTrample(e)">
                                    <img src="../../../../static/images/icon/icon51.png" alt="" v-if="e.is_cai">
                                    <img src="../../../../static/images/icon/icon40.png" alt="" v-else>
                                    <div>{{ e.cai_num }}</div>
                                </div>
                                <div class="list-box-txt-box-r-cz">
                                    <img src="../../../../static/images/icon/icon41.png" alt="">
                                    <div>{{ e.comment_num }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { dynamicList, dynamicPraise, dynamicTrample } from '@/api/user'

    export default {
        data() {
            return {
                categories: [[], []], // 动态列表（第一行、第二行）
                page: 1, // 分页
                lastScrollLeft: 0, // 记录上次滚动位置
                loading: false, // 动态列表加载状态
                noMore: false, // 动态列表是否全部加载完成
                // 动态卡片动画实例，用于组件销毁时释放动画资源
                dynamicCardAnimations: []
            };
        },
        mounted() {
            this.onDynamicList();
        },
        methods: {
            /**踩 */
            onTrample(e) {
                if (e.is_cai == 0 && e.is_zan == 1) {
                    e.zan_num--
                };
                e.is_cai == 0 ? e.cai_num++ : e.cai_num--;
                e.is_cai = e.is_cai == 0 ? 1 : 0;
                e.is_zan = 0;
                dynamicTrample({ id: e.id }).then(res => { })
            },
            /**赞 */
            onPraise(e) {
                if (e.is_cai == 1 && e.is_zan == 0) {
                    e.cai_num--
                };
                e.is_zan == 0 ? e.zan_num++ : e.zan_num--;
                e.is_zan = e.is_zan == 0 ? 1 : 0;
                e.is_cai = 0;

                dynamicPraise({ id: e.id }).then(res => { })
            },
            /** 动态列表 */
            async onDynamicList() {
                if (this.loading || this.noMore) return;

                this.loading = true;
                try {
                    const responses = await Promise.all([
                        dynamicList({ page: this.page, line: 1 }),
                        dynamicList({ page: this.page, line: 2 }),
                    ]);
                    const lists = responses.map(response => response.data.data || []);

                    if (!lists[0].length && !lists[1].length) {
                        this.noMore = true;
                        return;
                    }

                    this.$set(this.categories, 0, this.categories[0].concat(lists[0]));
                    this.$set(this.categories, 1, this.categories[1].concat(lists[1]));
                    this.page++;
                    this.$nextTick(() => {
                        this.playDynamicCardAnimation(lists[0].concat(lists[1]));
                    });
                } catch (error) {
                    console.error('加载动态列表失败：', error);
                } finally {
                    this.loading = false;
                }
            },

            /** 播放新加载动态卡片的入场动效 */
            playDynamicCardAnimation(newCards) {
                if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                    return;
                }
                const newCardIds = newCards.map(card => String(card.id));
                const cards = (this.$refs.dynamicCard || []).filter(card =>
                    newCardIds.indexOf(card.getAttribute('data-dynamic-id')) !== -1
                );
                if (!cards.length) {
                    return;
                }
                const animation = this.$gsap.from(cards, {
                    y: 16,
                    opacity: 0,
                    scale: 0.98,
                    duration: 0.45,
                    stagger: 0.08,
                    ease: 'power2.out',
                });
                this.dynamicCardAnimations.push(animation);
            },

            /** 处理滚动事件 */
            handleScroll(event) {
                const container = event.target;
                const { scrollLeft, scrollWidth, clientWidth } = container;

                // 检测是否向右滚动并且接近最右边
                if (scrollLeft > this.lastScrollLeft &&
                    scrollLeft + clientWidth >= scrollWidth - 100) {
                    this.onDynamicList();
                }

                this.lastScrollLeft = scrollLeft;
            },

            /** 专题详情 */
            onTopic(id) {
                this.$router.push({ name: 'TopicDetalis', params: { id } });
            }
        },
        beforeDestroy() {
            this.dynamicCardAnimations.forEach(animation => animation.kill());
        },
    };
</script>

<style scoped lang="scss">
    .classify {
        text-align: center;
        background: #f2f7f1;
        padding: 16px 12px 20px;
        position: relative;
        border-radius: 8px;
        margin: 0 var(--page-gutter);
        overflow: hidden;

        @media (min-width: 768px) {
            padding: 24px 40px 40px;
        }

        @media (min-width: 1280px) {
            padding: 24px 64px 40px;
        }


        .classify-t {
            /* // padding: 0 162px 40px; */
            padding-bottom: 20px;
            justify-content: center;

            .classify-t-tit {
                font-size: 22px;
                color: #333333;

                @media (min-width: 768px) {
                    font-size: 30px;
                }
            }
        }

        .list {
            width: 100%;
            overflow-x: auto;
            overflow-y: hidden;
            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;
            padding-bottom: 16px;

            @media (max-width: 767px) {
                padding-bottom: 0;
                -ms-overflow-style: none;
                scrollbar-width: none;

                &::-webkit-scrollbar {
                    display: none;
                    width: 0;
                    height: 0;
                }
            }

            /* // 新增滚动条样式 */
            &::-webkit-scrollbar {
                /* 滚动条高度（横向滚动条的高度） */
                height: 8px;
            }

            /* // 滚动条轨道 */
            &::-webkit-scrollbar-track {
                /* 轨道背景色 */
                background: #D9D9D9;
                /* 轨道圆角（与高度匹配，使轨道呈圆角矩形） */
                border-radius: 4px;
            }

            /* // 滚动条滑块（实际可拖动的部分） */
            &::-webkit-scrollbar-thumb {
                /* 滑块宽度（即滚动条的长度） */
                width: 60px;
                /* 滑块颜色 */
                background: #000000;
                /* 滑块圆角 */
                border-radius: 4px;
            }

            /* // 滑块hover状态 */
            &::-webkit-scrollbar-thumb:hover {
                /* hover时的颜色 */
                background: #000000;
            }

            .classify-list {
                display: flex;
                flex-direction: column;
                gap: 12px;
                width: max-content;

                @media (min-width: 768px) {
                    gap: 24px;
                }

                .classify-row {
                    display: flex;
                    gap: 12px;

                    @media (min-width: 768px) {
                        gap: 24px;
                    }
                }

                .list-box {
                    width: 220px;
                    height: 168px;

                    @media (min-width: 768px) {
                        width: 372px;
                        height: 268px;
                    }
                    border-radius: 8px;
                    overflow: hidden;
                    position: relative;
                    cursor: pointer;

                    .img-container {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;

                        .img-container-img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transition: transform 0.5s ease;
                        }
                    }

                    &:hover {
                        .img-container-img {
                            transform: scale(1.2);
                        }
                    }

                    .list-box-title {
                        position: absolute;
                        top: 10px;
                        left: 10px;
                        right: 10px;
                        z-index: 2;
                        font-size: 13px;
                        line-height: 1.35;
                        max-height: 2.7em;
                        color: #FFFFFF;
                        text-align: left;
                        overflow: hidden;
                        word-break: break-word;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        /* autoprefixer: ignore next */
                        -webkit-box-orient: vertical;
                        text-overflow: ellipsis;
                        text-shadow: 0 1px 4px rgba(0, 0, 0, 0.55);

                        @media (min-width: 768px) {
                            top: 20px;
                            left: 20px;
                            right: 20px;
                            font-size: 20px;
                            max-height: 2.7em;
                        }
                    }

                    .list-box-txt {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        color: #FFFFFF;
                        padding: 10px;
                        text-align: left;
                        background: linear-gradient(transparent, rgba(0, 0, 0, 0.75));
                        width: 100%;
                        max-height: 78%;
                        z-index: 1;
                        box-sizing: border-box;
                        overflow: hidden;

                        @media (min-width: 768px) {
                            padding: 20px;
                            max-height: none;
                        }

                        .list-box-txt-box {
                            display: flex;
                            flex-direction: column;
                            align-items: stretch;
                            gap: 8px;
                            min-width: 0;

                            @media (min-width: 768px) {
                                flex-direction: row;
                                align-items: flex-end;
                            }

                            .list-box-txt-box-l {
                                flex: 1;
                                min-width: 0;
                                width: 100%;

                                .list-box-desc {
                                    font-size: 11px;
                                    line-height: 1.4;
                                    max-height: 2.8em;
                                    overflow: hidden;
                                    word-break: break-word;
                                    opacity: 0.9;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    /* autoprefixer: ignore next */
                                    -webkit-box-orient: vertical;
                                    text-overflow: ellipsis;

                                    @media (min-width: 768px) {
                                        font-size: 16px;
                                    }
                                }
                            }

                            .list-box-txt-box-r {
                                display: flex;
                                align-items: center;
                                justify-content: flex-start;
                                flex: none;
                                width: 100%;
                                min-width: 0;
                                gap: 12px;
                                font-size: 11px;

                                @media (min-width: 768px) {
                                    justify-content: space-between;
                                    width: 54%;
                                    gap: 0;
                                    font-size: 16px;
                                }

                                .list-box-txt-box-r-cz {
                                    width: auto;
                                    flex: none;
                                    display: flex;
                                    align-items: center;
                                    text-align: left;
                                    gap: 4px;

                                    @media (min-width: 768px) {
                                        width: 33%;
                                        flex-direction: column;
                                        justify-content: center;
                                        text-align: center;
                                        gap: 0;
                                    }

                                    img {
                                        width: 14px;
                                        height: 14px;
                                        margin-bottom: 0;
                                        flex-shrink: 0;

                                        @media (min-width: 768px) {
                                            width: 20px;
                                            height: 20px;
                                            margin-bottom: 4px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .loading,
            .no-more {
                padding: 20px;
                text-align: center;
                color: #666;
            }
        }

        /* 隐藏滚动条 */
        /* .list::-webkit-scrollbar {
            // display: none;
        } */
    }
</style>



// WEBPACK FOOTER //
// src/view/home/components/classifyList.vue